module.exports = __webpack_public_path__ + "img/b43b85f.jpg";